/**
 * Com `!` (important) de propósito: estas classes pintam células do Material (`mat-cell`,
 * `mat-header-cell`), cujo `display` vem do tema — CSS SEM camada, que vence qualquer utility do
 * Tailwind 4 (que vive em `@layer utilities`) por cascata, qualquer que seja a especificidade.
 * Sem o `!`, `hidden` não esconde nada e não avisa — mesma armadilha do `text-red-600` em
 * `mat-icon` (skill frontend).
 */
export enum TailwindBreakpointHiddenClass {
  sm = 'sm:hidden!',
  md = 'md:hidden!',
  lg = 'lg:hidden!',
  xl = 'xl:hidden!',
  '2xl' = '2xl:hidden!',

  // Exibir apenas em resoluções maiores
  'lg-only' = 'hidden! lg:inline-flex!',
  'xl-only' = 'hidden! xl:inline-flex!',
  '2xl-only' = 'hidden! 2xl:inline-flex!',
}
